<template>
  <div id="contact" class="contact">
    <div class="contact__section contact__header">
      <div class="contact__header__title">{{ $t('Contact us') }}</div>
      <div class="contact__header__subtitle">
        {{ $t('Our staff is available to you at the following contacts') }}
      </div>
    </div>
    <ContactDetails class="contact__section" />
    <ContactForm
      :key="updater"
      :formspree-form-id="formspreeFormId"
      class="contact__section"
      @onSubmit="updater = updater + 1"
    >
      <template #title>
        <div class="group-title">
          <h2 class="title">
            {{ $t('Contact us') }}
          </h2>
        </div>
      </template>
    </ContactForm>
    <Organization />
    <LocalBusiness />
  </div>
</template>

<script>
import {
  useMeta,
  computed,
  useContext,
  defineComponent,
  ref,
} from '@nuxtjs/composition-api';
import { ContactForm, ContactDetails } from '~/components/Contact';
import Organization from '~/components/StructuredData/Organization.vue';
import LocalBusiness from '~/components/StructuredData/LocalBusiness.vue';
import { handleSeo } from '~/helpers/seo/handleSeo';
// import { useGtm } from '~/composables';
// import { handleSeo } from '~/helpers/seo/handleSeo';

export default defineComponent({
  name: 'Contact',
  components: {
    ContactForm,
    ContactDetails,
    Organization,
    LocalBusiness,
  },
  head: {},
  setup() {
    const { app } = useContext();

    const updater = ref(0);
    const metaTitle = computed(
      () => app.i18n.t('Contact') + ' - Sogni di Cristallo®'
    );
    const metaDescription = computed(() =>
      app.i18n.t(
        'You can contact us by email (info@sognidicristallo.it) or call us at (+39) 041 4762538'
      )
    );
    const formspreeFormId = ref(process.env.formspreeContactPageFormId);
    // const { pageGtmPush } = useGtm();

    // onMounted(() => {
    //   pageGtmPush(metaTitle.value);
    //   canonicalUrl.value = [getCanonical()];
    // });
    const { getCanonical } = handleSeo();
    const canonicalLink = computed(() => getCanonical());

    useMeta(() => ({
      title: metaTitle.value,
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: metaTitle.value,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: metaTitle.value,
        },
        {
          hid: 'description',
          name: 'description',
          content: metaDescription.value,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: metaDescription.value,
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'index, follow',
        },
      ],
      link: [
        {
          ...canonicalLink.value,
        },
      ],
    }));

    return {
      updater,
      metaTitle,
      metaDescription,
      canonicalLink,
      formspreeFormId,
    };
  },
});
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 1.25rem;
  &__section {
    width: 100%;
    padding: 2.5rem 0;
    &:not(:last-child) {
      border-bottom: var(--general-border);
    }
  }
  &__header {
    &__title {
      @include mobile-h4;
      text-align: center;
    }
    &__subtitle {
      margin-top: 1.25rem;
      @include paragraph-l;
      text-align: center;
    }
  }
  @include from-desktop-min {
    &__header {
      margin-top: 3.75rem;
      &__title {
        @include desktop-h4;
      }
    }
  }
}
</style>
